import Vue from 'vue'

export default {
  upload: async (file, progress, indicatorValue, indicatorField) => {
    let formData = new FormData()
    formData.append('document', file)

    if (indicatorValue && indicatorValue.id) {
      formData.append('indicator_value', indicatorValue.id)
    }

    if (indicatorField && indicatorField.id) {
      formData.append('indicator_field', indicatorField.id)
    }

    return Vue.axios.post('/documents/upload', formData, {
      onUploadProgress: progress
    })
  },
  delete: async (file) => {
    return Vue.axios.post('/documents/'+file.id+'/delete')
  },
  url: async (file) => {
    return Vue.axios.get('documents/'+file.id+'/url')
  }
}
